import Class from './class'

export default Class.create('EventGenerator', {
  construct: function () {
    this.__listeners = {}
  },

  addListener: function (evt, cb, ctx) {
    (this.__listeners[evt] || (this.__listeners[evt] = [])).push({ ctx: ctx, cb: cb })
  },

  addListenerOnce: function (evt, cb, ctx) {
    var f = function(data) { this.removeListener(evt, f, this); if (cb) cb.call(ctx, data) }
    this.addListener(evt, f, this)
  },

  removeListener: function (evt, cb, ctx) {
    if (!cb) {
      this.__listeners[evt] = null
    }
    else {
      var cbs = this.__listeners[evt]
      if (cbs) {
        for (var i = 0; i < cbs.length; i++) {
          if ((cbs[i].cb === cb) && (cbs[i].ctx === ctx)) {
            cbs.splice(i, 1)
            break
          }
        }
      }
    }
  },

  fire: function (evt, data) {
    var cbs = this.__listeners[evt]
    if (cbs) {
      for (var i = 0; i < cbs.length; i++) {
        if (cbs[i].cb) cbs[i].cb.call(cbs[i].ctx, data)
      }
    }
  }
})
